import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Button, Spinner, } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { createUserApi, getDepartmentsApi, getDesignationsByDepartmentApi, } from "../../../apiServices/service";
import { resetUserPasswordApi, updateUserApi, } from "../../../apiServices/adminWork.services";
import CommonModal from "../../../components/Common/CommonModal";
import DepartmentForm from "../Departments/DepartmentForm";
import DesignationForm from "../Designations/DesignationForm";
const CreateUser = ({ isModal = false, onSuccess, mode, selectedUser }) => {
  const [loading, setLoading] = useState(false);
  const [showPasswordFields,setShowPasswordFields] = useState(false);
  const authUserData = JSON.parse(localStorage.getItem("authUser") || "{}");
  const myCRM = authUserData?.response?.email || authUserData?.email || authUserData?.user?.email;
  const userRole = authUserData?.response?.role || authUserData?.role || authUserData?.user?.role;
  const IsMaster = myCRM === "freelancer.harsh1198@gmail.com" || userRole === "super_admin";
  // console.log(IsMaster);
  const [dropdownLoading, setDropdownLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [showDesignation, setShowDesignation] = useState(false);
  const [designations, setDesignations] = useState([]);
  // const [managers, setManagers] = useState([]);
  const [deptModal, setDeptModal] = useState(false);
  const [desigModal, setDesigModal] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    role: "employee",
    departmentId: "",
    designationId: "",
  });
  const [changePassword, setChangePassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [showCreatedPassword, setShowCreatedPassword] = useState(false);
  const generatePassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const number = "0123456789";
    const special = "@#$%&*!";

    const all = upper + lower + number + special;

    let password =
      upper[Math.floor(Math.random() * upper.length)] +
      lower[Math.floor(Math.random() * lower.length)] +
      number[Math.floor(Math.random() * number.length)] +
      special[Math.floor(Math.random() * special.length)];

    for (let i = 0; i < 8; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    return password
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");
  };

  useEffect(() => {
    if (mode !== "edit") {
      const pwd = generatePassword();
      setGeneratedPassword(pwd);
      setConfirmPassword(pwd);
      setFormData((p) => ({
        ...p,
        password: pwd,
      }));
    }
  }, []);

  useEffect(() => {
    const initEditData = async () => {
      if (mode === "edit" && selectedUser) {
        const deptId = selectedUser.departmentId?._id || "";

        setFormData({
          firstName: selectedUser.firstName || "",
          lastName: selectedUser.lastName || "",
          email: selectedUser.email || "",
          mobile: selectedUser.mobile || "",
          password: "",
          role: selectedUser.role || "employee",
          departmentId: deptId,
          designationId: selectedUser.designationId?._id || "",
        });

        if (deptId) {
          try {
            const res = await getDesignationsByDepartmentApi(deptId);
            setDesignations(res?.data || []);
            setShowDesignation(true);
          } catch (err) {
            console.error(err);
          }
        }
      }
    };

    initEditData();
  }, [mode, selectedUser]);
  const fetchDropdowns = async () => {
    try {
      setDropdownLoading(true);

      const deptRes = await getDepartmentsApi();

      setDepartments(deptRes?.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load dropdown data");
    } finally {
      setDropdownLoading(false);
    }
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstName || !formData.email) {
      toast.error("Required fields missing");
      return;
    }

    try {
      setLoading(true);

      if (mode === "edit") {
        const updatedFields = {};
        Object.keys(formData).forEach((key) => {
          const oldValue =
            key === "departmentId"
              ? selectedUser?.departmentId?._id
              : key === "designationId"
                ? selectedUser?.designationId?._id
                : selectedUser[key];

          if (formData[key] !== oldValue && formData[key] !== "") {
            updatedFields[key] = formData[key];
          }
        });

        if (Object.keys(updatedFields).length === 0) {
          toast.info("No changes made");
          return;
        }

        await updateUserApi(selectedUser._id, updatedFields);
        toast.success("User updated successfully");

        if (showPasswordFields) {
          if (!formData.password || !confirmPassword) {
            return toast.error("Password required");
          }

          if (formData.password !== confirmPassword) {
            return toast.error("Passwords do not match");
          }

          await resetUserPasswordApi(selectedUser._id, {
            password: formData.password,
          });

          toast.success("Password updated");
        }
      } else {
        await createUserApi(formData);
        toast.success("User created successfully");
        setShowCreatedPassword(true);
      }
      const createdPassword = formData.password;

      setGeneratedPassword(createdPassword);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        role: "employee",
        departmentId: "",
        designationId: "",
      });

      setConfirmPassword("");
      setShowDesignation(false);
      setDesignations([]);
      onSuccess && onSuccess();
    } catch (error) {
      if (
        error?.error === "Email already exists" ||
        error?.message === "Email already exists"
      ) {
        toast.error("Email already exists");
        return;
      }

      toast.error(error?.error || error?.message || "Failed");
    } finally {
      setLoading(false);
    }
  };
  const handleDepartmentChange = async (e) => {
    const { value } = e.target;

    setFormData({
      ...formData,
      departmentId: value,
      designationId: "",
    });

    if (!value) {
      setShowDesignation(false);
      setDesignations([]);
      return;
    }

    try {
      const res = await getDesignationsByDepartmentApi(value);
      setDesignations(res?.data || []);
      setShowDesignation(true);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load designations");
    }
  };
  const content = (
    <Container fluid={!isModal}>
      <Row className="justify-content-center">
        <Col xl={isModal ? 12 : 8} lg={isModal ? 12 : 10}>
          <Card className="shadow-sm border-0">
            {!isModal && (
              <CardHeader className="bg-light">
                <h4 className="mb-0 text-primary">
                  <i className="mdi mdi-account-plus-outline me-2"></i>
                  Create User
                </h4>
              </CardHeader>
            )}

            <CardBody>
              {dropdownLoading ? (
                <div className="text-center py-4">
                  <Spinner />
                </div>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>First Name *</Label>
                        <Input
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label>Last Name</Label>
                        <Input
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label>Email *</Label>
                        <Input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label>Mobile</Label>
                        <Input
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    {(mode !== "edit" || showPasswordFields) && (
                      <Col md={6}>
                        <FormGroup className="position-relative">
                          <Label>Password {mode === "create" && "*"}</Label>
                          <Input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required={mode !== "create"}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="btn btn-link position-absolute end-0"
                            style={{
                              top: "70%",
                              transform: "translateY(-50%)",
                            }}
                          >
                            <i
                              className={`mdi mdi-eye${showPassword ? "-off" : ""}`}
                            />
                          </button>
                        </FormGroup>
                      </Col>
                    )}
                    {showPasswordFields && (
                      <Col md={6}>
                        <FormGroup>
                          <Label>Confirm Password *</Label>
                          <Input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                        </FormGroup>
                      </Col>
                    )}
                    <Col md={6}>
                      <FormGroup>
                        <Label>Role</Label>
                        <Input
                          type="select"
                          name="role"
                          value={formData.role}
                          onChange={handleChange}
                        >
                          {IsMaster ? (
                            <>
                              <option value="super_admin">Super Admin</option>
                              <option value="admin">Admin</option>
                              <option value="employee">Employee</option>
                            </>
                          ) : (
                            <>
                              {formData.role === "super_admin" && (
                                <option value="super_admin">Super Admin</option>
                              )}
                              {formData.role === "admin" && (
                                <option value="admin">Admin</option>
                              )}
                              <option value="employee">Employee</option>
                            </>
                          )}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label>Department</Label>

                        <div className="d-flex gap-2">
                          <Input
                            type="select"
                            name="departmentId"
                            value={formData.departmentId}
                            onChange={handleDepartmentChange}
                          >
                            <option value="">Select</option>
                            {departments.map((d) => (
                              <option key={d._id} value={d._id}>
                                {d.name}
                              </option>
                            ))}
                          </Input>

                          <Button
                            color="primary"
                            onClick={() => setDeptModal(true)}
                            className="btn px-2.5"
                          >
                            +
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>

                    {showDesignation && (
                      <Col md={6}>
                        <FormGroup>
                          <Label>Designation</Label>

                          <div className="d-flex gap-2">
                            <Input
                              type="select"
                              name="designationId"
                              value={formData.designationId}
                              onChange={handleChange}
                            >
                              <option value="">Select</option>
                              {designations.map((d) => (
                                <option key={d._id} value={d._id}>
                                  {d.title} - {d.level}
                                </option>
                              ))}
                            </Input>

                            <Button
                              color="primary"
                              onClick={() => setDesigModal(true)}
                              className="btn px-2"
                            >
                              +
                            </Button>
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  {showCreatedPassword && generatedPassword && (
                    <div className="alert alert-success position-relative">
                      <button
                        type="button"
                        className="btn-close position-absolute"
                        style={{ top: "10px", right: "10px", fontSize: "10px" }}
                        onClick={() => setShowCreatedPassword(false)}
                      />

                      <div className="fw-bold mb-2">
                        User Created Successfully
                      </div>

                      <div className="small text-muted mb-1">
                        Temporary Password
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <code>{generatedPassword}</code>

                        <Button
                          size="sm"
                          color="success"
                          type="button"
                          onClick={() => {
                            navigator.clipboard.writeText(generatedPassword);
                            toast.success("Password copied");
                          }}
                        >
                          Copy
                        </Button>
                      </div>
                    </div>
                  )}
                  <div className="justify-content-end d-flex gap-2 mt-3">
                    
                    
                    {mode==="edit" && !showPasswordFields && (
                        <Button
                          color="warning"
                          type="button"
                          onClick={()=>{
                            setShowPasswordFields(true);
                            setChangePassword(true);
                          }}
                        >
                          Change Password
                        </Button>
                    )}
                    <Button color="primary" disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          {mode === "edit" ? "Updating..." : "Creating..."}
                        </>
                      ) : mode === "edit" ? (
                        "Update User"
                      ) : (
                        "Create User"
                      )}
                    </Button>
                  </div>
                </Form>
              )}
              <CommonModal
                isOpen={deptModal}
                toggle={() => setDeptModal(false)}
                title="Create Department"
              >
                <DepartmentForm
                  isModal
                  onSuccess={async () => {
                    setDeptModal(false);

                    const res = await getDepartmentsApi();
                    setDepartments(res?.data?.data || []);
                  }}
                />
              </CommonModal>

              <CommonModal
                isOpen={desigModal}
                toggle={() => setDesigModal(false)}
                title="Create Designation"
              >
                <DesignationForm
                  isModal
                  onSuccess={async () => {
                    setDesigModal(false);

                    if (formData.departmentId) {
                      const res = await getDesignationsByDepartmentApi(
                        formData.departmentId,
                      );
                      setDesignations(res?.data || []);
                    }
                  }}
                />
              </CommonModal>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );

  return isModal ? (
    content
  ) : (
    <div className="page-content">
      <Breadcrumbs title="Team" breadcrumbItem="Create User" />
      {content}
    </div>
  );
};

export default CreateUser;
